import axiosInstance from '../helpers/axios';
import { sendWhatsApp, template4 } from '../helpers/whatsappApi';
import { types } from '../types/types';
import { getToken } from './auth';
import { getIndividualAreas } from './individualAreas';
import { getOrderInfo, updateOrder } from './orders';
import { getProcesses } from './process';
import { handleError, handleSuccess } from '../helpers/utils';

// Add current bias
export const setCurrentBias = (data) => ({
	type: types.currentBias,
	payload: data,
});

// Add current bias
export const setBiases = (data) => ({
	type: types.setBiases,
	payload: data,
});

// Add bias data
export const addBias = (data) => ({
	type: types.addBias,
	payload: data,
});

// Set bias
export const setBias = (data) => ({
	type: types.setBias,
	payload: data,
});

// Set biases data
export const updateBiases = (data) => ({
	type: types.setBias,
	payload: data,
});

// Clean biases data
export const resetBiases = () => ({
	type: types.cleanBias,
});

// Set biases data
export const updateSubBiases = (data) => ({
	type: types.updateSubbiasesFlag,
	payload: data,
});

// Get all orders' biases
export const getBiases = async (idOrder) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/?order=${idOrder}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get all orders' biases (sorted)
export const getSortedBiases = async (
	idOrder,
	sortType = 'variant',
	area = null
) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/sorted/?order=${idOrder}&sort_type=${sortType}&area=${area}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get all orders' biases
export const getBiasesByBiasKey = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/?order=${data?.idOrder}&search=${data?.key}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get not-deleted-ordered-by-key subbiases from one bias
export const getSubBiases = async (idBias, ordering = 'key') => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/subbias/?bias=${idBias}&deleted=0&ordering=${ordering}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get subbiases from one bias
export const getSubBiasInfo = async (idSubBias) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/subbias/${idSubBias}?deleted=false`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register bias
export const registerBias = async (data) => {
	// Get token if authenticated
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/create/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Register subbias
export const registerSubBias = async (data) => {
	const token = getToken();
	axiosInstance({
		method: 'post',
		url: '/api/bias/subbias/create/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update bias
export const updateBias = async (id, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/update/${id}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update bias's status
export const updateBiasStatus = async (bias, status) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/update/${bias.id}`,
		headers: { Authorization: 'Bearer ' + token },
		data: {
			...bias,
			created_by: bias?.created_by?.id || null,
			garment: bias?.garment?.id || null,
			order: bias?.order?.id || null,
			variant: bias?.variant?.id || null,
			fabric: bias?.fabric?.id || null,
			variable: bias.variable.map((item) => item.id),
			status,
		},
	});
};

// Update bias's delivery forecast
export const updateBiasDeliveryForecast = async (bias, newDeliveryForecast) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/update/${bias.id}`,
		headers: { Authorization: 'Bearer ' + token },
		data: {
			...bias,
			created_by: bias?.created_by?.id || null,
			garment: bias?.garment?.id || null,
			order: bias?.order?.id || null,
			variant: bias?.variant?.id || null,
			fabric: bias?.fabric?.id || null,
			variable: bias?.variable.map((item) => item.id),
			delivery_forecast: newDeliveryForecast,
		},
	});
};

// Update subbias
export const updateSubBias = async (id, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/subbias/update/${id}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update subbias's status
export const updateSubbiasStatus = async (subbiasId, status) => {
	const token = getToken();
	const subbias = (await getSubBiasInfo(subbiasId)).data;
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/subbias/update/${subbiasId}`,
		headers: { Authorization: 'Bearer ' + token },
		data: {
			...subbias,
			size: subbias.size.id,
			created_by: subbias.created_by.id,
			status,
		},
	});
};

// Update subbiases's delivery forecast by giving subbiases ids
export const updateSubbiasDeliveryForecast = async (
	subbiasIds,
	daysResidue,
	set_date = false
) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/subbias/update-delivery-forecast-list',
		headers: { Authorization: 'Bearer ' + token },
		data: {
			subbias_ids: subbiasIds,
			days_residue: daysResidue,
			set_date,
		},
	});
};

// Update subbiases's delivery forecast by giving order id
export const updateDeliveryForecast = async (
	order_id = null,
	new_date = null,
	today = null
) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/subbias/update-delivery-forecast-by-order-id',
		headers: { Authorization: 'Bearer ' + token },
		data: {
			order_id,
			new_date,
			today,
		},
	});
};

// Check if the list of subbiases are valid to perform a date operation
export const checkPossibleProcess = async (
	action_option = null,
	subbiases_ids = [],
	area = '',
	bias_id = null
) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/subbias/check-possible-process',
		headers: { Authorization: 'Bearer ' + token },
		data: {
			action_option,
			subbiases_ids,
			area,
			bias_id,
		},
	});
};

// Set dates, calculate general progress and forecast dates
export const actionProcess = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/subbias/action-process',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Calculate a delivery forecast date average
export const calculateDeliveryForecastBias = async (biasId) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/subbias/calculate-average-date',
		headers: { Authorization: 'Bearer ' + token },
		data: { bias_id: biasId },
	});
};

// Get bias info
export const getBiasInfo = async (id) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/${id}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Delete bias
export const deleteBias = async (id) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/bias/${id}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Delete subbias (set 'deleted' field to true)
export const deleteSubBias = async (id, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/subbias/update/${id}`,
		headers: { Authorization: 'Bearer ' + token },
		data: {
			...data,
			size: data.size.id,
			deleted: true,
		},
	});
};

// Watch out whith this one...
export const reallyDeleteSubBias = async (id) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/bias/subbias/${id}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

export const checkWhichSubbiasesAlreadyHasThisArea = async (
	subbiasesIds,
	biasId,
	area
) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/check-any-subbias-already-has-area',
		headers: { Authorization: 'Bearer ' + token },
		data: {
			subbias_ids: subbiasesIds,
			bias_id: biasId,
			area: area,
		},
	});
};

export const updateMultipleSubbiasesStatus = async (
	subbiasesIds,
	status,
	area,
	user_id
) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/subbias/update-status-list',
		headers: { Authorization: 'Bearer ' + token },
		data: {
			subbias_ids: subbiasesIds,
			status,
			area,
			user_id,
		},
	});
};

// Calculate progresses
export const calculateProgresses = async (subbiasId, biasId, orderId) => {
	try {
		await calculateSubBiasProgress(subbiasId, biasId);
		await calculateBiasProgress(biasId);
		await calculateOrderProgress(orderId);
		console.log('Progresses calculated correctly');
	} catch (error) {
		console.log('Progresses calculated INcorrectly');
		console.log(error);
	}
};

// Calculate subbias progress
export const calculateSubBiasProgress = async (subbiasId, biasId) => {
	const subbias = (await getSubBiasInfo(subbiasId)).data;

	// These admin areas are not taken as part of the progress calculus
	const adminAreas = ['Mesa de Control', 'Logística', 'Facturación'];

	// Get lists
	const { results: individualAreas } = (await getIndividualAreas(biasId))
		.data;
	const { results: processes } = (await getProcesses(subbias.id)).data;
	const activeAreas = individualAreas.filter(
		(area) => area.active && !adminAreas.includes(area.name)
	);

	const completedProcesses = processes.map((item) =>
		// 0.5 means it only has entry date and no final date
		item.entry_date && item.final_date ? 1 : 0.5
	);

	let numerator = 0;

	// Get numerator and denominator
	completedProcesses.forEach((item) => (numerator += item)); // Number of completed + half completed areas
	const denominator = activeAreas.length; // Number of areas

	// Calculate progress
	const progress = Math.round((numerator / denominator) * 100);

	return await updateSubBias(subbias.id, {
		...subbias,
		size: subbias.size.id,
		created_by: subbias.created_by.id,
		progress: progress >= 100 ? 100 : progress,
		status: progress >= 100 ? 'FIN' : subbias.status,
	});
};

// Calculate bias progress
export const calculateBiasProgress = async (biasId) => {
	const bias = (await getBiasInfo(biasId)).data;
	const { results: subbiases } = (await getSubBiases(bias.id)).data;

	// Get numerator and denominator
	let numerator = 0; // Subbiases accumulated progress
	const denominator = subbiases.length; // Number of subbiases

	subbiases.forEach((subbias) => {
		numerator += subbias.progress;
	});

	// Calculate progress
	const progress = Math.round(numerator / denominator);

	return await updateBias(bias.id, {
		...bias,
		created_by: bias?.created_by?.id || null,
		garment: bias?.garment?.id || null,
		order: bias?.order?.id || null,
		variant: bias?.variant?.id || null,
		fabric: bias?.fabric?.id || null,
		variable: bias?.variable.map((item) => item.id),
		progress,
		status: progress === 100 ? 'FIN' : bias.status,
	});
};

// Calculate order progress
export const calculateOrderProgress = async (orderId) => {
	const order = (await getOrderInfo(orderId)).data;

	const { results: biases } = (await getBiases(order.id)).data;

	// Get numerator and denominator
	let numerator = 0; // Biases accumulated progress
	const denominator = biases.length; // Number of biases

	biases.forEach((subbias) => {
		numerator += subbias.progress;
	});

	// Calculate progress
	const progress = Math.round(numerator / denominator);

	if (progress === 100) {
		// Send WhatsApp to report the order has been completed
		await sendWhatsApp(order.contacts, template4(order?.number_order));
	}

	return await updateOrder(order.id, {
		...order,
		client_id: order.client_id.id,
		created_by: order.created_by.id,
		progress,
		contacts: order.contacts.map((item) => item.id),
		status: progress === 100 ? 'FIN' : order.status,
	});
};

export const getResults = async (date1, date2) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/summary-orders/',
		headers: { Authorization: 'Bearer ' + token },
		data: {
			date_1: date1,
			date_2: date2,
		},
	});
};

export const getResultsExcel = async (date1, date2) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/summary-orders-excel/?date_1=${date1}&date_2=${date2}`,
		responseType: 'blob',
		headers: { Authorization: 'Bearer ' + token },
	})
		.then((response) => {
			try {
				// URL
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);

				// Create link
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `resumen_de_pedidos.xlsx`);

				// Set link
				document.body.appendChild(link);
				link.click();
				handleSuccess('Reporte generado');
			} catch (error) {
				handleError(
					error,
					'Hubo un error al crear el reporte el resumen de pedidos [1]'
				);
			}
		})
		.catch((error) => {
			handleError(
				error,
				'Hubo un error al crear el reporte el resumen de pedidos [2]'
			);
		});
};

// Update logistics
export const updateBiasLogistics = async (biasId) => {
	const token = getToken();
	axiosInstance({
		method: 'put',
		url: '/api/bias/subbias/update-logistics',
		headers: { Authorization: 'Bearer ' + token },
		data: { id: biasId },
	});
};

// Get contact list for process form
export const getContactListFinalProcessForm = async (biasId) => {
	const token = getToken();
	axiosInstance({
		method: 'get',
		url: '/api/bias/subbias/get-contact-list-process-form',
		headers: { Authorization: 'Bearer ' + token },
		data: { id: biasId },
	});
};
